import { Col, Row, Avatar, Menu, Drawer, Grid } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { StyledLink } from "../styled-components/components";
import { useHistory } from "react-router";
import profile from "../../images/profile.svg";
import { NavLink } from "react-router-dom";
import { Notifications } from "./Header";

const ConsultantHeader = ({
  getAllNotifications,
  readAllNotifications,
  signOut,
}) => {
  let history = useHistory();
  const [openSliderMenu, setOpenSliderMenu] = useState(false);
  const screens = Grid.useBreakpoint();
  useEffect(() => {
    if (screens.lg || screens.xl || screens.xxl) {
      setOpenSliderMenu(false);
    }
  }, [screens]);
  const { profileImageUrl } = useSelector((state) => state.userStore);
  const [isImageUrl, setIsImageUrl] = useState(false);
  useEffect(() => {
    if (!profileImageUrl) {
      setIsImageUrl(false);
    } else {
      setIsImageUrl(true);
    }
  }, [profileImageUrl]);
  return (
    <Col xs={{ span: 14 }} lg={{ span: 18 }} xl={{ span: 11 }}>
      <Col xs={{ span: 0 }} lg={{ span: 24 }}>
        <Row justify="space-between" align="middle">
          <Col>
            <NavLink
              to="/consultant/dashboard"
              activeClassName="selected"
              activeStyle={{
                color: "#1565d8",
                fontSize: "16px",
                fontWeight: "600",
              }}
              data-testid="submit-dashboard"
              onClick={() => history.push("/consultant/dashboard")}
            >
              Dashboard
            </NavLink>
          </Col>

          <Col>
            <NavLink
              to="/consultant/home"
              activeClassName="selected"
              activeStyle={{
                color: "#1565d8",
                fontSize: "16px",
                fontWeight: "600",
              }}
              data-testid="submit-homePage"
            >
              Home
            </NavLink>
          </Col>
          <Col>
            <NavLink
              to="/consultant/applications"
              activeClassName="selected"
              activeStyle={{
                color: "#1565d8",
                fontSize: "16px",
                fontWeight: "600",
              }}
              data-testid="submit-myApplications"
            >
              My Applications
            </NavLink>
          </Col>
          <Col>
            <NavLink
              to="/consultant/offers"
              activeClassName="selected"
              activeStyle={{
                color: "#1565d8",
                fontSize: "16px",
                fontWeight: "600",
              }}
              data-testid="submit-myOffers"
            >
              Offers
            </NavLink>
          </Col>
          <Col>
            <NavLink
              to="/consultant/jobs"
              activeClassName="selected"
              activeStyle={{
                color: "#1565d8",
                fontSize: "16px",
                fontWeight: "600",
              }}
              data-testid="submit-currentJobs"
            >
              Current Jobs
            </NavLink>
          </Col>

          <Col>
            <Notifications
              getAllNotifications={getAllNotifications}
              readAllNotifications={readAllNotifications}
            />
          </Col>
          <Col>
            <Menu mode="horizontal" style={{ border: "none" }}>
              <Menu.SubMenu
                title={
                  <Avatar
                    size="large"
                    src={!isImageUrl ? profile : profileImageUrl}
                    data-testid="profile-avatar"
                  ></Avatar>
                }
              >
                <Menu.Item>
                  <Col>
                    <NavLink
                      to="/consultant/profile/account"
                      activeClassName="selected"
                      activeStyle={{
                        color: "#1565d8",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                      data-testid="submit-profile"
                    >
                      Profile
                    </NavLink>
                  </Col>
                </Menu.Item>
                <Menu.Item
                  data-testid="submit-changePassword"
                  onClick={() => history.push("/change-password")}
                >
                  Change Password
                </Menu.Item>
                <Menu.Item
                  data-testid="submit-signOut"
                  onClick={() => signOut()}
                >
                  Sign Out
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </Col>
        </Row>
      </Col>
      <Col xs={{ span: 24 }} lg={{ span: 0 }}>
        <Row justify="end">
          <MenuOutlined onClick={() => setOpenSliderMenu(true)} />
        </Row>
        <Drawer visible={openSliderMenu} closable={false}>
          <Col>
            <Row justify="end">
              <CloseOutlined onClick={() => setOpenSliderMenu(false)} />
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/consultant/home"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-homePage"
              >
                Home
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/consultant/profile/account"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-profile"
              >
                Profile
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/consultant/dashboard"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-dashboard"
              >
                Dashboard
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/consultant/applications"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-myApplications"
              >
                My Applications
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/consultant/offers"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-myOffers"
              >
                My Offers
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/consultant/jobs"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-currentJobs"
              >
                Current Jobs
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/change-password"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-changePassword"
              >
                Change Password
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <StyledLink
                data-testid="submit-signOut"
                onClick={() => signOut()}
              >
                Sign Out
              </StyledLink>
            </Row>
          </Col>
        </Drawer>
      </Col>
    </Col>
  );
};

export default ConsultantHeader;
